<template>
	<div class="result-container" :class="(visualisationType ? 'result-container-' + visualisationType : '')">
		<div v-if="reachedEnd" class="reached-end row middle-text">
			<strong>Tak for jeres deltagelse!<br/><br/>Vi ses næste år.</strong>
		</div>
		<div v-else-if="loading" class="loading row middle-text">
			<strong>Henter data..</strong>
		</div>
		<div v-else-if="!currentPoll" class="row middle-text">
			<strong>(der er ikke noget data at visualisere)</strong>
		</div>
		<div v-else-if="currentPoll && (!visualisationEnabled || currentPollType === 'freetext')"
		     class="row question-middle">
			<div class="container-fluid">
				<p class="question-summary row">Opgave {{ currentPollIndex + 1}}</p>
				<p class="question-text row">{{ currentPoll.question }}</p>
			</div>
		</div>
		<div v-else-if="showResults && currentPoll && visualisationEnabled" class="row results-container">
			<div class="container-fluid">
				<div class="current-quiz-title row" :class="showResults ? 'with-results' : 'without-results'">
					<div class="container-fluid">
						<p class="question-summary row">Opgave {{ currentPollIndex + 1}}</p>
						<p class="question-text row">{{ currentPoll.question }}</p>
					</div>
				</div>

				<transition name="fade">
					<div class="results row" v-if="visualisationType === 'chart' || visualisationType === 'classStep'"
					     :key="visualisationType">
						<div class="container-fluid results-horizontal-inner">
							<div
									class="col result-column"
									v-for="(result, i) in results"
									:key="i"
							>
								<result-horizontal
										:showBarLabels="visualisationType === 'classStep'"
										:index="i"
										:identifier="result.identifier"
										:labels="result.labels"
										:percentages="result.percentages"
										:largestIndex="result.largestIndex"
								/>
							</div>
						</div>
					</div>
					<div class="results row" v-else-if="visualisationType === 'area'" key="area">
						<div
								class="col result-column"
								v-for="(result, i) in results"
								:key="i"
						>
							<result-area
									:index="i"
									:identifier="result.identifier"
									:labels="result.labels"
									:percentages="result.percentages"
									:largestIndex="result.largestIndex"
							/>
						</div>
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
	import * as MutationTypes from '@/store/mutation-types'
	import {mapGetters} from 'vuex';
	import ResultArea from '@/components/results/result-area'
	import ResultHorizontal from '@/components/results/result-horizontal'
	import Vue from 'vue';

	export default {
		name: 'manager-control-panel-view',
		components: {
			//Choice,
			//ResultProgressBar,
			ResultArea,
			ResultHorizontal
		},
		data() {
			return {
				actuallyMount: false,

				loading: true,
				results: [],

				visualisationType: 'chart',
				visualisationEnabled: null,
				currentPollIndex: null,

				fetchVotesTimeout: null,

				reachedEnd: false,
			}
		},
		mounted() {
			if (!this.actuallyMount) {
				return;
			}

			this.loading = true;

			this.$apiClient.noErrorHandler().loadData().then((data) => {
				this.$store.commit(MutationTypes.SET_POLLS, data.polls);

				this.$echoClient.listenNewActivePoll(this.onNewActivePoll);
				this.$echoClient.listenVisualisationUpdated(this.onVisualisationUpdated);
				this.$echoClient.listenReachedEnd(this.onReachedEnd);

				this.$apiClient.noErrorHandler().loadManagerData().then((data) => {
					this.visualisationEnabled = data.visualisationEnabled;
					this.visualisationType = data.visualisationType;

					this.$apiClient.noErrorHandler().loadGameData().then((data) => {
						this.loading = false;
						this.reachedEnd = data.reachedEnd;

						if (data.currentPollId) {
							this.setPollIndexByPollId(data.currentPollId);

							this.fetchVotes();
						}
					}).catch(() => {
						this.loading = false;

						this.results = [];
					});
				}).catch(() => {
					this.loading = false;

					this.results = [];
				});
			}).catch(() => {
				this.loading = false;

				this.results = [];
			});
		},
		destroyed() {
			this.$echoClient.stopListeningAll();

			if (this.fetchVotesTimeout) {
				clearTimeout(this.fetchVotesTimeout);

				this.fetchVotesTimeout = null;
			}
		},
		computed: {
			...mapGetters({
				polls: 'getPolls',
			}),
			showResults() {
				return this.visualisationEnabled;
			},
			currentPoll() {
				if (this.currentPollIndex === null) {
					return false;
				}

				return this.polls[this.currentPollIndex];
			},
			options() {
				if (!this.currentPoll) {
					return [];
				}

				return this.currentPoll.options;
			},
			currentPollTitle() {
				if (this.currentPoll) {
					return `Opgave ${this.currentPollIndex + 1}: ${this.currentPoll.question}`;
				} else {
					return 'Afstemning ikke startet endnu';
				}
			},
			currentPollType() {
				if (this.currentPoll) {
					return this.currentPoll.type;
				}

				return null;
			},
		},
		beforeMount() {
			let managerCode = this.$apiClient.getHttp().defaults.headers.common['X-Manager-Code'];

			if (!managerCode) {
				this.$router.push('/manager/');

				this.actuallyMount = false;

				return;
			}

			this.actuallyMount = true;

			if (this.fetchVotesTimeout) {
				clearTimeout(this.fetchVotesTimeout);

				this.fetchVotesTimeout = null;
			}
		},
		methods: {
			getClassStepFromIdentifier(identifier) {
				identifier = identifier.toString();

				if (identifier === '8') {
					return '8. klasse';
				} else if (identifier === '9') {
					return '9. klasse';
				} else {
					return '';
				}
			},
			onReachedEnd() {
				this.reachedEnd = true;
			},
			onNewActivePoll(data) {
				this.$store.commit(MutationTypes.SET_CURRENT_POLL_ID, data.pollId);

				this.setPollIndexByPollId(data.pollId);
				this.fetchVotes(true);
			},
			fetchVotes(forceUpdate = false) {
				if (this.fetchVotesTimeout) {
					clearTimeout(this.fetchVotesTimeout);

					this.fetchVotesTimeout = null;
				}

				console.log('getVoteResults');

				this.$apiClient.noErrorHandler().getVoteResults(this.currentPoll.id, this.visualisationType).then(
					(data) => {
						this.onVotesUpdated(data, forceUpdate);
					}).catch((e) => {
					// Most likely it's just complaining about the fact that it couldn't look up any votes for "freetext" answers
				}).finally(() => {
					this.fetchVotesTimeout = setTimeout(this.fetchVotes, 5000);
				});
			},
			onVotesUpdated(votes, forceUpdate = false) {
				this.loading = false;

				let results = [];

				if (this.visualisationType === 'area') {
					for (let identifier in votes) {
						let identifierVotes = votes[identifier];

						let len = Math.min(this.options.length, identifierVotes.length, 2);

						let voteValuesTotal = 0, largestPercentage = 0, largestResultIndex = null;

						for (let i = 0; i < len; i++) {
							voteValuesTotal += identifierVotes[i];
						}

						if (voteValuesTotal > 0) {
							let percentages = [];
							let labels = [];

							for (let i = 0; i < len; i++) {
								let percentage = (identifierVotes[i] / voteValuesTotal) * 100;

								if (percentage > largestPercentage) {
									largestPercentage = percentage;
									largestResultIndex = i;
								}

								percentages.push(percentage);
								labels.push(this.options[i]);
							}

							percentages = percentages.splice(0, 2);
							labels = labels.splice(0, 2);

							results.push({
								percentages: percentages,
								labels: labels,
								largestIndex: largestResultIndex,
								identifier: identifier.toString(),
							});
						} else {
							let percentages = [];
							let labels = [];

							for (let i = 0; i < len; i++) {
								percentages.push(0);
								labels.push(this.options[i]);
							}

							percentages = percentages.splice(0, 2);
							labels = labels.splice(0, 2);

							results.push({
								percentages: percentages,
								labels: labels,
								largestIndex: 0,
								identifier: identifier.toString(),
							});
						}
					}
				} else if (this.visualisationType === 'classStep') {
					let votesReverse = {};

					let identifiers = [], identifierIndexes = {};

					for (let identifier in votes) {
						identifierIndexes[identifier] = identifiers.length;
						identifiers.push(identifier);
					}

					for (let i = 0; i < this.options.length; i++) {
						let option = this.options[i];

						for (let identifier in votes) {
							let identifierIndex = identifierIndexes[identifier];

							if (!votesReverse.hasOwnProperty(option)) {
								votesReverse[option] = [];
							}

							votesReverse[option][identifierIndex] = votes[identifier][i];
						}
					}

					for (let identifier in votesReverse) {
						let identifierVotes = votesReverse[identifier];

						let len = Math.min(identifiers.length, identifierVotes.length);

						let voteValuesTotal = 0, largestPercentage = 0, largestResultIndex = null;

						for (let i = 0; i < len; i++) {
							voteValuesTotal += identifierVotes[i];
						}

						if (voteValuesTotal > 0) {
							let percentages = [];
							let labels = [];

							for (let i = 0; i < len; i++) {
								let percentage = (identifierVotes[i] / voteValuesTotal) * 100;

								if (percentage > largestPercentage) {
									largestPercentage = percentage;
									largestResultIndex = i;
								}

								percentages.push(percentage);

								labels.push(this.getClassStepFromIdentifier(identifiers[i]));
							}

							results.push({
								percentages: percentages,
								labels: labels,
								largestIndex: largestResultIndex,
								identifier: identifier.toString(),
							});
						} else {
							let percentages = [];
							let labels = [];

							for (let i = 0; i < len; i++) {
								percentages.push(0);
								labels.push(this.getClassStepFromIdentifier(identifiers[i]));
							}

							results.push({
								percentages: percentages,
								labels: labels,
								largestIndex: 0,
								identifier: identifier.toString(),
							});
						}
					}
				} else {
					let voteValuesTotal = 0;
					let largestPercentage = 0, largestResultIndex = null;

					let len = Math.min(this.options.length, votes.length);

					for (let i = 0; i < len; i++) {
						voteValuesTotal += votes[i];
					}

					if (voteValuesTotal > 0) {
						for (let i = 0; i < len; i++) {
							let percentage = (votes[i] / voteValuesTotal) * 100;

							if (percentage > largestPercentage) {
								largestPercentage = percentage;
								largestResultIndex = i;
							}
						}

						for (let i = 0; i < len; i++) {
							let percentage = (votes[i] / voteValuesTotal) * 100;

							results.push({
								percentages: [percentage],
								labels: [this.options[i]],
								largestIndex: largestResultIndex,
								identifier: this.options[i],
							});
						}
					} else {
						for (let i = 0; i < len; i++) {
							results.push({
								percentages: [0],
								labels: [this.options[i]],
								largestIndex: 0,
								identifier: this.options[i],
							});
						}
					}
				}

				let resultLength = results.length;

				if (forceUpdate || this.results.length !== resultLength) {
					// Reset all of them, result length is different
					this.results = results;
				} else {
					// Update them individually
					for (let i = 0; i < resultLength; i++) {
						let result = results[i];

						for (let key in result) {
							let resultValue = result[key];

							if (resultValue instanceof Array) {
								for (let j = 0, jLen = resultValue.length; j < jLen; j++) {
									Vue.set(this.results[i][key], j, resultValue[j]);
								}
							} else {
								Vue.set(this.results[i], key, resultValue);
							}
						}
					}
				}

				console.log(this.results);
			},
			setPollIndexByPollId(pollId) {
				for (let i = 0, len = this.polls.length; i < len; i++) {
					if (this.polls[i].id === pollId) {
						this.currentPollIndex = i;

						break;
					}
				}
			},
			onVisualisationUpdated(data) {
				this.visualisationType = data.visualisationType;
				this.visualisationEnabled = data.visualisationEnabled;
			},
		},
		watch: {
			visualisationType(visualisationType) {
				this.results = [];
				this.loading = true;

				this.$nextTick(() => {
					this.fetchVotes(true);
				});
			},
			visualisationEnabled(visualisationEnabled) {
				this.results = [];
				this.loading = true;

				this.$nextTick(() => {
					this.fetchVotes(true);
				});
			}
		}
	}
</script>

<style lang="scss">
	#app {
		height: 100%;

		> .container {
			height: 100%;

			> .manager-container {
				height: 100%;

				> .control-panel-container {
					height: 100%;
				}
			}
		}
	}
</style>
<style lang="scss" scoped>
	.intro-container {
	}

	.results {
		height: 900px;
	}

	.result-container-area {
		.question-text {
			font-size: 30pt;
		}
	}

	.question-text {
		font-size: 30pt;
		font-weight: bold;

	}

	.middle-text {
		font-weight: bold;
		font-size: 60pt;
		@include alignCenter();
		text-align: center;
	}

	.current-quiz-row {
		padding: 10px;
		background: #f0f0f0;
		font-weight: bold;

		&.without-result {
			@include alignCenterY();
		}

		.question-summary {
		}

		.question-text {
			font-weight: bold;
			font-size: 24pt;
		}
	}

	.logo-container {
		text-align: center;

		margin: 0 auto;

		img {
			max-width: 200px;
		}
	}

	h1 {
		text-align: center;
		line-height: 100%;

		margin-bottom: 0;
	}

	p {
		text-align: center;
		font-size: 10pt;
	}

	.button-container {
		text-align: center;
	}

	.info-value {
		font-weight: bold;
	}

	.results-container {
		position: relative;
		height: 80%;
	}

	.result-bar-container {
		position: relative;
		height: 100%;
	}

	.result-bar-wrapper {
		width: 100%;
		height: 100%;
	}

	.result-bar {
		width: 80%;
		border: 1px solid black;
		position: absolute;
		left: 0;
		bottom: 0;
		transition: ease-in-out;
		transition-duration: 200ms;
		transition-property: height;

		&.result-bar-1 {
			background-color: $bar1color1;
		}

		&.result-bar-2 {
			background-color: $bar2color1;
		}

		&.result-bar-3 {
			background-color: $bar3color1;
		}
	}

	.result-value {
		position: absolute;
		left: 0;
		bottom: -40px;
		width: 100%;
		text-align: center;
		font-weight: bold;
		font-size: 20pt;
	}

	.results-container {
		.question-summary {
			font-size: 18pt;
			background: #FF001E;
			color: white;
			font-style: italic;
			font-weight: bold;
			font-style: italic;
			padding: 0px 15px;
			text-transform: uppercase;
			width: 300px;
		}
	}

	.question-middle {
		@include alignCenter();
		transform: translate(-50%, -80%);
		margin-left: 0px;

		width: 90%;

		.question-summary {
			display: block;
			font-size: 60px;
			font-weight: bold;
			text-align: center;
			border-bottom: 3px solid black;
			text-transform: uppercase;
			color: black;
			padding: 0px 15px 20px 15px;
			width: 500px;
			margin: 0 auto 30px auto;
		}

		.question-text {
			display: block;
			text-align: center;
			font-size: 80px;
			font-weight: bold;
		}
	}

	.current-quiz-title {
		.question-text {
			text-align: left;
			font-size: 55pt;
		}
	}

	/*.result-container {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		padding: 0 100px;
	}*/

	.current-quiz-title {
		margin-top: 70px;
		padding-left: 80px;
	}

	.results-horizontal-inner {
		padding-right: 320px;
		padding-left: 80px;
	}
</style>
